import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense } from 'react';
import { PageLoading } from 'components/atoms/loading';
import { TokenErrorStatus } from 'components/organisms/token-error/constant';
import { useLoginWithToken } from 'hooks/use-login-with-token';
const TokenError = /*#__PURE__*/ React.lazy(()=>import('components/organisms/token-error/token-error').then((d)=>({
            default: d.TokenError
        })));
export const LoginWithToken = ({ token, tokenType })=>{
    const [, isError] = useLoginWithToken(token, tokenType);
    if (isError) {
        return /*#__PURE__*/ _jsx(Suspense, {
            fallback: /*#__PURE__*/ _jsx(PageLoading, {}),
            children: /*#__PURE__*/ _jsx(TokenError, {
                status: TokenErrorStatus.Invalid
            })
        });
    }
    return /*#__PURE__*/ _jsx(PageLoading, {});
};
